import { useState } from "react";
import { login } from "../lib/api";
import type { AppConfig } from "../types";

interface Props {
  config: AppConfig;
  onLogin: (token: string, email: string) => void;
  onConfigUrl: (u: string) => void;
}

export function Login({ config, onLogin, onConfigUrl }: Props) {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function entrar() {
    setBusy(true);
    setErr(null);
    try {
      const r = await login(config, email, pass);
      onLogin(r.access_token, r.email);
    } catch (e: any) {
      setErr(e.message || String(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <div className="login-card">
        <div className="brand big">
          <span className="dot" /> SupriAI Launcher
        </div>
        <p className="muted">CRM Suprimentos — copiloto interno com agentes</p>

        <label>API URL
          <input value={config.apiUrl} onChange={(e) => onConfigUrl(e.target.value)} />
        </label>
        <label>Email
          <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="seu email da equipe" />
        </label>
        <label>Senha
          <input type="password" value={pass} onChange={(e) => setPass(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") entrar(); }} />
        </label>
        {err && <div className="error">⚠ {err}</div>}
        <button onClick={entrar} disabled={busy || !email || !pass}>
          {busy ? "entrando…" : "Entrar"}
        </button>
        <small className="muted">v0.1 · {config.apiUrl}</small>
      </div>
    </div>
  );
}
